import { FC } from 'react';
import { useForm } from 'react-final-form';
import { ColorFieldInput } from './ColorFieldInput';

export interface FullPaletteField {
  name: string;
  label: string;
  description?: string;
}
interface FullPaletteProps {
  fields: FullPaletteField[];
}

export const FullPalette: FC<FullPaletteProps> = ({ fields }) => {
  const { change } = useForm();

  const handleResetColors = () => {
    fields.forEach(f => change(f.name, null));
  };

  const rows = fields
    .map((_, i) => i)
    .filter(i => i % 2 === 0)
    .map(i => ({ left: fields[i], right: fields[i + 1] }));

  return (
    <div className="column gap4">
      {rows.map(({ left, right }) => (
        <div className="row" key={`row-${left.name}`}>
          <ColorFieldInput field={left} />
          {right && <div className="col-md-2" />}
          {right && <ColorFieldInput field={right} />}
        </div>
      ))}

      <div className="row">
        <button type="button" className="show-reset-button link-text" onClick={handleResetColors}>
          Reset Colors
        </button>
      </div>
    </div>
  );
};
